export const environment = {
    production: false,
    apiUrl: 'https://fuchs.dev.thinkupc.com/api',
    //apiUrl: 'http://localhost:3000/api'
};
